import React from 'react';
import GridOptionItem from './GridOptionItem';

interface TransportationOption {
    title: string;
    description: string[];
    imgComponent: (arg: boolean) => React.ReactNode;
    url: string;
}

interface TransportationOptionsProps {
    transportationOptions: TransportationOption[];
    selectedMode?: 'hotel' | 'cruise';
    onSelect?: (mode: 'hotel' | 'cruise') => void;
}

function TransportationOptions({ transportationOptions, selectedMode, onSelect }: TransportationOptionsProps) {
    return (
        <div className="optionsGrid">
            {transportationOptions.map((option, index) => (
                <GridOptionItem
                    key={index}
                    option={option}
                    selectedMode={selectedMode}
                    onSelect={onSelect}
                />
            ))}
        </div>
    );
}

export default TransportationOptions;
